'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../../node_modules/prop-types/index.js');

var Link = require('../../../primitives/Link/Link.js');

var useExternalLink = require('../../../utilities/hooks/useExternalLink.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var ArticleListItemImage = function ArticleListItemImage(props) {
  var alt = props.alt,
      empty = props.empty,
      href = props.href,
      image = props.image,
      subtitle = props.subtitle,
      title = props.title,
      sectionTitle = props.sectionTitle;

  var renderTitle = function renderTitle() {
    return title && !empty ? /*#__PURE__*/React__default['default'].createElement(useExternalLink.GatsbyLink, {
      href: href,
      className: "title text"
    }, title) : /*#__PURE__*/React__default['default'].createElement("div", {
      className: "title text"
    }, title);
  };

  var renderSubtitle = function renderSubtitle() {
    return subtitle && !empty ? /*#__PURE__*/React__default['default'].createElement(useExternalLink.GatsbyLink, {
      href: href,
      className: "subtitle text"
    }, subtitle) : /*#__PURE__*/React__default['default'].createElement("div", {
      className: "subtitle text"
    }, subtitle);
  };

  var renderReadMore = function renderReadMore() {
    return !empty && /*#__PURE__*/React__default['default'].createElement(Link.Link, {
      href: href,
      className: "link"
    }, "Read More", /*#__PURE__*/React__default['default'].createElement("span", {
      className: "sr-only"
    }, "about the article: ", title));
  };

  var renderImage = function renderImage() {
    return image && !empty ? /*#__PURE__*/React__default['default'].createElement(useExternalLink.GatsbyLink, {
      href: href,
      className: "image-link rollover",
      "aria-label": alt
    }, /*#__PURE__*/React__default['default'].createElement("img", {
      alt: alt,
      src: image,
      loading: "lazy"
    })) : /*#__PURE__*/React__default['default'].createElement("img", {
      alt: alt,
      src: image,
      loading: "lazy"
    });
  };

  return /*#__PURE__*/React__default['default'].createElement("li", {
    className: "lanl-article-list-item",
    "data-testid": "lanl-article-list-item"
  }, sectionTitle && /*#__PURE__*/React__default['default'].createElement("h3", {
    className: "section-title"
  }, sectionTitle), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "content"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "div-img"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "lanl-image-container"
  }, renderImage())), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "div-title"
  }, renderTitle()), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "div-text"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "div-text-body"
  }, renderSubtitle(), renderReadMore()))));
};

ArticleListItemImage.defaultProps = {};
ArticleListItemImage.propTypes = {
  alt: index['default'].string.isRequired,
  href: index['default'].string.isRequired,
  image: index['default'].string.isRequired,
  title: index['default'].string.isRequired,
  empty: index['default'].bool,
  sectionTitle: index['default'].string,
  subtitle: index['default'].string
};
exports.ArticleListItemImage = ArticleListItemImage;
exports['default'] = ArticleListItemImage;